import pkg from '../../../package.json';

export class CacheBusterService {
  constructor($window, $log) {
    this.$window = $window;
    this.$log = $log;
    
    this.currentVersion = pkg.version;
    this.storedVersion = localStorage.getItem('ars_version');
    
    this.checkVersion();
  }
  
  checkVersion() {
    if (!this.storedVersion) {
      localStorage.setItem('ars_version', this.currentVersion);
      return;
    }
    
    if (this.storedVersion !== this.currentVersion) {
      this.$log.info(`Version changed from ${this.storedVersion} to ${this.currentVersion}. Refreshing.`);
      localStorage.setItem('ars_version', this.currentVersion);

      this.$window.location.reload(true);
    }
  }
}